<template>
    <component :is="Listing" v-bind="$attrs as any">
        <template #header>
            <slot name="header" />
        </template>
    </component>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import Feature from 'Services/Feature';

defineOptions({ inheritAttrs: false });

const Listing = Feature.isEnabled('new-listing-ui')
    ? defineAsyncComponent(() => import('vcomponents/listing/Listing.vue'))
    : defineAsyncComponent(() => import('vcomponents/listing/legacy/Listing.vue'));
</script>
